import { Slider } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setScale, setRotate } from '../redux-tool/slice/controlSlice';
import { updateCurrentLogo } from '../js/webGL';

export function Control() {
  const dispatch = useDispatch();
  const { scale, rotate, show } = useSelector((state) => state.control);

  const handleScaleChange = (event, value) => {
    dispatch(setScale(value));
    updateCurrentLogo(value, rotate);
  };

  const handleRotateChange = (event, value) => {
    dispatch(setRotate(value));
    updateCurrentLogo(scale, value);
  };

  return (
    <>
      {show && (
        <div className="control-top-toolbar">
          <div className="control-row">
            <div className="control-label">Scale</div>
            <Slider
              className="control-slider"
              value={scale}
              onChange={(event, value) => handleScaleChange(event, value)}
              min={2}
              max={8.0}
              step={0.2}
            />
          </div>
          <div className="control-row">
            <div className="control-label">Rotate</div>
            <Slider
              className="control-slider"
              value={rotate}
              onChange={(event, value) => handleRotateChange(event, value)}
              min={-180}
              max={180}
              step={1}
            ></Slider>
          </div>
        </div>
      )}
    </>
  );
}
